<template>
  <div class="auth-page d-flex justify-content-center align-items-center py-4">
    <div class="auth-card shadow-lg p-4 p-md-5 text-center">
      <div v-if="loading" class="py-4">
        <div class="spinner-border text-primary" role="status" />
        <p class="mt-3 mb-0 text-muted">Подтверждаем e-mail…</p>
      </div>
      <template v-else>
        <i
          class="fa-2x mb-3"
          :class="verified ? 'fa-solid fa-circle-check text-success' : 'fa-solid fa-circle-xmark text-danger'"
        />
        <h1 class="h5 fw-semibold">{{ title }}</h1>
        <p class="text-muted small mb-4">{{ detail }}</p>
        <router-link v-if="verified" to="/login" class="btn btn-primary">Войти</router-link>
        <router-link v-else to="/login" class="btn btn-outline-primary">На страницу входа</router-link>
      </template>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import api from '@/api'

const route = useRoute()
const loading = ref(true)
const verified = ref(false)
const title = ref('')
const detail = ref('')

onMounted(async () => {
  const token = (route.query.token || '').toString().trim()
  if (!token) {
    loading.value = false
    verified.value = false
    title.value = 'Ссылка недействительна'
    detail.value = 'Токен подтверждения не найден.'
    return
  }
  try {
    const { data } = await api.get('/auth/verify-email/', { params: { token } })
    verified.value = !!data?.verified
    title.value = verified.value ? 'E-mail подтверждён' : 'Не удалось подтвердить'
    detail.value = data?.detail || ''
  } catch (e) {
    verified.value = false
    title.value = 'Ссылка недействительна'
    detail.value = e?.response?.data?.detail || 'Ссылка истекла или уже использована.'
  } finally {
    loading.value = false
  }
})
</script>

<style scoped>
.auth-page {
  min-height: 100vh;
  padding: 1.5rem;
}
.auth-card {
  width: 100%;
  max-width: 480px;
  border-radius: 1rem;
  background: #fff;
}
</style>
